import axios from "axios";
import { endpoints } from "@app/api/apis";




export const searchIFSC = async ({ bankCode , searchText }: { bankCode: string , searchText: string  }) => {
  const response = await axios.get(endpoints.bankInfoSearch + bankCode.toUpperCase() + '/' + searchText.toUpperCase());
  return response.data;
};